import React from 'react';
import { history } from '../store';
import '../styles/QRsAdminView.css'

class CustomerList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterOpen: true,
      filters: {
        customer: '',
        group: '',
        country: '',
        mode: '',
        type: '',
      },
    };
    this.toggleFilter = this.toggleFilter.bind(this)
    this.handleBlockClick = this.handleBlockClick.bind(this)
  }

  goTo(id, e) {
    history.push(`/customers/${id}`);
  }

  handleBlockClick(customer, e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onToggleBlock(customer._id);
  }

  toggleFilter() {
    this.setState(prev => ({ filterOpen: !prev.filterOpen }))
  }

  handleFilterChange(filterKey, value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterKey]: value,
      },
    }));
  }

  getSAPConversion(model) {
    switch (model) {
      case 'CV': return 'COMISION VENTA';
      case 'VC': return 'VENTAS CONTADO';
      default: return model || '—';
    }
  }

  render() {
    const { filters, filterOpen } = this.state;
    const { customers, role } = this.props;
    const isAdmin = role === 'ADMIN';

    const filteredCustomers = customers.filter(customer => {
      const { customer: customerFilter, group: groupFilter, country: countryFilter, mode: modeFilter, type: typeFilter } = filters;
      if (customerFilter && (!customer.Fullname || !customer.Fullname.toLowerCase().includes(customerFilter.toLowerCase()))) return false;
      if (groupFilter && (!customer.Group || !customer.Group.toLowerCase().includes(groupFilter.toLowerCase()))) return false;
      if (countryFilter && (!customer.Country || !customer.Country.toLowerCase().includes(countryFilter.toLowerCase()))) return false;
      if (modeFilter && (!customer.BusinessModel || !customer.BusinessModel.toLowerCase().includes(modeFilter.toLowerCase()))) return false;
      if (typeFilter && (!customer.Type || customer.Type !== typeFilter)) return false;
      return true;
    });

    return (
      <div>
        {/* Collapsible Filter Panel */}
        <div className="qrs-admin-filter-card">
          <div className="qrs-admin-filter-header" onClick={this.toggleFilter}>
            <h3><i className="fas fa-filter"></i> Filtros</h3>
            <i className={`fas fa-chevron-down toggle-icon ${filterOpen ? 'open' : ''}`}></i>
          </div>
          {filterOpen && (
            <div className="qrs-admin-filter-body">
              <div className="filter-grid">
                <div className="filter-group">
                  <label>Cliente</label>
                  <input
                    type="text"
                    placeholder="Buscar por cliente..."
                    value={filters.customer}
                    onChange={e => this.handleFilterChange('customer', e.target.value)}
                  />
                </div>
                <div className="filter-group">
                  <label>Tipo</label>
                  <select value={filters.type} onChange={e => this.handleFilterChange('type', e.target.value)}>
                    <option value="">Todos</option>
                    <option value="GENERAL">GENERAL</option>
                    <option value="GROUP">GROUP</option>
                  </select>
                </div>
                <div className="filter-group">
                  <label>Grupo</label>
                  <input
                    type="text"
                    placeholder="Buscar por grupo..."
                    value={filters.group}
                    onChange={e => this.handleFilterChange('group', e.target.value)}
                  />
                </div>
                <div className="filter-group">
                  <label>País</label>
                  <input
                    type="text"
                    placeholder="Buscar por país..."
                    value={filters.country}
                    onChange={e => this.handleFilterChange('country', e.target.value)}
                  />
                </div>
                <div className="filter-group">
                  <label>Modo</label>
                  <select value={filters.mode} onChange={e => this.handleFilterChange('mode', e.target.value)}>
                    <option value="">Todos</option>
                    <option value="REVENUE SHARE">REVENUE SHARE</option>
                    <option value="SPACE RENTAL">SPACE RENTAL</option>
                    <option value="SALE">VENTA</option>
                    <option value="RENTAL">ALQUILER</option>
                  </select>
                </div>
                <div className="filter-group filter-actions">
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                    <button type="button" className="btn btn-light" onClick={() => this.setState({ filters: { customer: '', group: '', country: '', mode: '', type: '' } })}>Limpiar</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Column Headers */}
        <div className="qrs-admin-list-header">
          <div className="qrs-header-col col-customer">Nombre completo</div>
          <div className="qrs-header-col col-customer">Grupo</div>
          <div className="qrs-header-col col-id">País</div>
          <div className="qrs-header-col col-versions">Modo</div>
          <div className="qrs-header-col col-payments">SAP</div>
          <div className="qrs-header-col col-payments">Teléfono</div>
          <div className="qrs-header-col col-payments">E-Mail</div>
          {isAdmin && (
            <div className="qrs-header-col col-actions">Acciones</div>
          )}
        </div>

        {/* Cards */}
        <div className="qrs-admin-list">
          {filteredCustomers.length > 0 ? (
            filteredCustomers
              .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
              .map(customer => (
                <div key={customer._id} className="qrs-admin-card" onClick={e => this.goTo(customer._id, e)}>
                  <div className="qrs-admin-row">
                    <div className={`qrs-admin-status-bar ${customer.isBlocked ? 'DISABLED' : 'ENABLED'}`}></div>
                    <div className="qrs-admin-content">
                      <div className="qrs-admin-machine-customer">
                        <div className="qrs-admin-customer-name">
                          {customer.Fullname}
                          {customer.isBlocked && (
                            <span className="cust-meta-badge blocked ml-2">
                              <i className="fas fa-ban mr-1"></i>Bloqueado
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="qrs-admin-machine-customer">
                        <div style={{ fontWeight: 600 }}>{customer.Group || '—'}</div>
                      </div>
                      <div className="qrs-admin-machine-id">
                        <div className="qrs-admin-sub">{customer.Country || '—'}</div>
                      </div>
                      <div className="qrs-admin-machine-versions">
                        <div className="qrs-admin-sub">{customer.BusinessModel || '—'}</div>
                      </div>
                      <div className="qrs-admin-machine-payments">
                        <div className="qrs-admin-sub">{this.getSAPConversion(customer.SAP?.Model)}</div>
                      </div>
                      <div className="qrs-admin-machine-payments">
                        <div className="qrs-admin-sub">{customer.Phone || '—'}</div>
                      </div>
                      <div className="qrs-admin-machine-payments">
                        <div className="qrs-admin-sub">{customer.Email || '—'}</div>
                      </div>
                      {isAdmin && (
                        <div className="qrs-admin-machine-actions">
                          <button
                            className={`qrs-admin-card-action-btn ${customer.isBlocked ? 'unblock' : 'block'}`}
                            onClick={e => this.handleBlockClick(customer, e)}
                          >
                            <i className={`fas ${customer.isBlocked ? 'fa-lock-open' : 'fa-ban'}`}></i>
                            {customer.isBlocked ? 'Desbloquear' : 'Bloquear'}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))
          ) : (
            <div className="qrs-admin-empty">
              <i className="fas fa-users"></i>
              <p>No se encontraron clientes</p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CustomerList;